/**
 * Created by liubo on 16/1/25.
 */
import React from 'react'
import ReactDOM from 'react-dom';

import ConfigureStore from './configureStore';
//创建程序入口
export default function CreateEntry(param){
    var entry = {
        $el: param.$el || document.getElementById('bs-main')
        ,reducers: param.reducers
        ,routes: param.routes
        ,middleware:param.middleware || []
    };
    const store = ConfigureStore(entry.reducers,entry.middleware);
    //结合saga兼容代码
    var midd = entry.middleware
    midd.map(function(item) {
        if (item.name ==='sagaMiddleware' && param.actions) {
            item.run(param.actions)
        }
    })
    return store;
}